<template>
  <n-link :to="link" tag="div" class="deck-banner-link">
    <div :style="{background: bgColor}" class="deck-banner-link--thumbnail">
      <img v-if="image" :src="image" :alt="label">
    </div>
    <h3 class="truncate">{{ label }}</h3>
    <!-- <div v-if="subtitle" class="subtitle">{{ subtitle }}</div> -->
  </n-link>
</template>

<script>
export default {
  name: 'DeckBannerLink',
  props: {
    image: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    themeData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    colors () {
      return this.themeData?.colors?.colors || {}
    },
    bgColor () {
      return this.colors?.primary || '#333'
    }
  }
}
</script>

<style scoped lang="scss">
@import "/assets/css/components";

$default-size: 8rem;
$wide-size: 12rem;

.deck-banner-link {
  text-align: center;
  cursor: pointer;
  color: currentColor;
  background-color: rgb(223, 242, 248);
  background-color: white;
  padding: 10px 10px;
  border-radius: 6px;
  transition: transform .13s ease;
  width: 100%;

  .deck-banner-link--thumbnail {
    //border: 1px solid $light-white;
    border-radius: $border-radius-sm;
    color: $white;
    background: $light-grey;
    transform-origin: 50% 50%;
    transition: transform .13s ease;
    width: 100%;
    height: 6.5rem;

    img {
      width: 100%;
      height: 100%;
      border-radius: $border-radius-sm;
      opacity: .7;
      object-fit: cover;
      transition: opacity .13s ease;
    }
  }

  &:hover {
    transform: scale(1.02, 1.02);
    // box-shadow: 0px 4px 12px -2px rgba(0,0,0,.07);

    .deck-banner-link--thumbnail {
      img {
        opacity: .75;
      }
    }
  }

  h3 {
    font-size: $font-size-4;
    text-align: left;
    margin-top: $margin-1;
    font-weight: 600;
  }

  .truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .subtitle {
    font-size: $font-size-5;
    text-align: left;
    color: $muted;
  }
}
</style>
